import styled from 'styled-components';
import colors from '../../../styles/colors';
import GenericRenderContainerSection from './GenericRenderContainerSection';

const SingleBeltContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 5px;
    column-gap: 5px;
    /* background-color: ${colors.bgColorBlack2}; */
    /* border-radius: 8px; */

    & img {
        width: 25px;
        height: 25px;
        object-fit: contain;
    }

    & .belt-name {
        font-size: 9px;
        font-weight: 500;
        color: white;
    }
`;

function AlboDoroWrestlerRender({
    belts
}) {
    return (
        <GenericRenderContainerSection>
            {belts.map((belt, key) => (
                <SingleBeltContainer key={key}>
                    <img src={process.env.REACT_APP_STORAGE_URL + belt.img_path} alt={belt.img_path + "_alt"} />
                    <span className='belt-name'>{belt.belt_count}x {belt.name}</span>
                </SingleBeltContainer>
            ))}
        </GenericRenderContainerSection>
    )
}

export default AlboDoroWrestlerRender;